// extracted by mini-css-extract-plugin
module.exports = {"card":"CardTwoBlock_card__GFR2L","skeleton-card":"CardTwoBlock_skeleton-card__FNLK8"};